import { render, staticRenderFns } from "./category.vue?vue&type=template&id=8d53baca&scoped=true&"
import script from "./category.vue?vue&type=script&lang=js&"
export * from "./category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d53baca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d53baca')) {
      api.createRecord('8d53baca', component.options)
    } else {
      api.reload('8d53baca', component.options)
    }
    module.hot.accept("./category.vue?vue&type=template&id=8d53baca&scoped=true&", function () {
      api.rerender('8d53baca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/child/category.vue"
export default component.exports